module.exports = __webpack_public_path__ + "img/np_gamification_3181746_000000.66022a3d.svg";